<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { getAppConfig } from "../../../common/config/app-config";
  import { getDateStringInCurrentLang, getStr, globalCurrencyTag } from "../../../common/util";
  import Icon from "../../common/components/Icon.svelte";
  import Text from "../../common/components/Text.svelte";
  import ProductDeliveryHeader from "./ProductDeliveryHeader.svelte";

  const {  lang } = getAppConfig();

  export let data;
  export let location;
  export let code;
  export let isCollectFromStoreEnabled;
  export let cfsPosPickUpInStoreData;

  
  
  const cpTitle = $_(getStr('extra.collectionpoint.product.collectionpointin.label'));
  
</script>
<section class="cp-info-section">
        <div class="cp-location">
            <ProductDeliveryHeader 
            collectionPointData={data}
            isCollectionPointPick={true}
            inStock = {data.stock?.stockLevelStatus?.code === 'inStock' || data.stock?.stockLevelStatus?.code === 'lowStock'}
            stockStatus={data.stock?.stockLevelStatus?.code}
            stockCount = {data.stock?.stockLevel}
            title={cpTitle}
            {location}
            {code}
            {isCollectFromStoreEnabled}
            {cfsPosPickUpInStoreData}
            />
        </div>
        <div class="cp-delivery-details">
            {#if data?.eligibleForCollectionPoint}
                <div class="cp-delivery-message">
                    <Icon glyph="icon-location-cp"type="primary" mobileSize={24} desktopSize={24} />
                    <div>
                        {#if data?.collectByDate}
                            <Text key="extra.collectionpoint.collectitby.label" args={[getDateStringInCurrentLang(data?.collectByDate, lang)]}/>
                        {/if}
                        {#if data?.collectionFee?.value > 0}
                            <span class="cp-fee"> <Text key="jood.price.with.currency" args={[globalCurrencyTag,data?.collectionFee.value]}/></span>
                        {/if}
                    </div>
                  </div>
            {:else}
                <span class="cp-oos-message"><Text key="extra.collectionpoint.cityavailability.label"/></span>
            {/if}
        </div>
</section>
<style lang="scss">
    @import '../../common/styles/colors.new.scss';
    
    .cp-info-section{
        .cp-location{
            align-items: center;
            display: flex;
            gap: 5px;
            margin-bottom: 15px;
            .cp-text{
                font-size: 16px;
                line-height: 18px;
            }
            .location{
                cursor: pointer;
                color: $icon-only-icon-blue;
                font-weight: 500;
                font-size: 16px;
                line-height: 18px;
                &.qacPopupOpen{
                    cursor: inherit;
                    color: $neutral-dark-01;
                }
            }
            
           
        }
        .cp-delivery-details{
          display: flex;
        }
        .cp-delivery-message{
            align-items: center;
            color: $neutral-dark-01;
            display: flex;
            font-size: 14px;
            gap: 12px;
            line-height: 16px;
            .cp-fee{
                color: $functional-orange-02;
                font-weight: 700;
                line-height: 18px;
                padding-left: 6px;
            }
        }
        .cp-oos-message{
            color: $functional-orange;
            font-size: 14px;
            line-height: 18px;
            font-weight: 700;
        }
    }
</style>